import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tj2",
  "use": "icon-tj2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tj2\"><path d=\"M624.7 698.6L446.4 319.8c-1-2.1-3.5-2.9-5.5-1.8L290 398.1c-2.3 1.2-4.9 1.9-7.5 1.9H136c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h133.6c0.7 0 1.3-0.2 1.9-0.5l195-103.6c4-2.1 9-0.5 11 3.7l171 363.3c1.1 2.4 4.3 3.1 6.3 1.3l170.4-150.9c4.2-3.7 10.7-2.1 12.8 3.1l84.9 216.5c1.6 4.1-0.4 8.8-4.5 10.4l-44.7 17.5c-4.1 1.6-8.8-0.4-10.4-4.5l-53.6-136.6c-1-2.6-4.3-3.4-6.4-1.5l-166.1 147c-4 3.5-10.2 2.2-12.5-2.6z\" p-id=\"3355\" /><path d=\"M1024 900v24c0 2.2-1.8 4-4 4H32c-17.7 0-32-14.3-32-32V100c0-2.2 1.8-4 4-4h24c2.2 0 4 1.8 4 4v788c0 4.4 3.6 8 8 8h88V452c0-2.2 1.8-4 4-4h216c2.2 0 4 1.8 4 4v444h64V448.5c0-8.4 11.2-11.1 15.1-3.7l156.4 298.6c2.8 5.3 8.2 8.6 14.2 8.6H636c2.2 0 4 1.8 4 4v140h64V739.3c0-2.1 0.8-4.2 2.3-5.7l58.4-58.4c1.7-1.7 4.6-1.5 6 0.4l42.8 57.1c1.5 2 3.9 3.2 6.4 3.2h104c2.2 0 4 1.8 4 4v156h92c2.3 0.1 4.1 1.9 4.1 4.1z\" p-id=\"3356\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-tj2.svg
// module id = UohN
// module chunks = 120